module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar",
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("坐视布管欢迎你!")]), _vm._v(" "), (_vm.isLogin) ? _c('span', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/loginPage"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/registerPage"
    }
  }, [_vm._v("免费注册")])], 1) : _c('span', [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.userInfo.userName))]), _vm._v(" "), _c('span', {
    staticClass: "logout",
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("[退出]")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('router-link', {
    staticClass: "link",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "to": "/personal/index"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.goAboutUs
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "app-qrcode"
  }, [_c('i', {
    staticClass: "iconfont icon-shouji"
  }), _vm._v(" "), _c('span', [_vm._v("坐视布管")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-content"
  }, [_c('div', {
    staticClass: "qrcode clearfix"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('ts-image', {
    attrs: {
      "src": "/static/images/qrcode/app.png",
      "width": "100",
      "height": "100",
      "canView": false,
      "disabledHover": ""
    }
  })], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "app-qrcode"
  }, [_c('i', {
    staticClass: "iconfont icon-weixin"
  }), _vm._v(" "), _c('span', [_vm._v("公众号")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-content"
  }, [_c('div', {
    staticClass: "qrcode clearfix"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('ts-image', {
    attrs: {
      "src": "/static/images/qrcode/qrcode_gzh.jpg",
      "width": "100",
      "height": "100",
      "canView": false,
      "disabledHover": ""
    }
  })], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("坐视布管APP")]), _vm._v(" "), _c('p', {
    staticClass: "red"
  }, [_vm._v("扫码即可下载")]), _vm._v(" "), _c('div', {
    staticClass: "app-type clearfix"
  }, [_c('div', {
    staticClass: "andriod"
  }, [_c('i', {
    staticClass: "iconfont icon-anzhuo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ios"
  }, [_c('i', {
    staticClass: "iconfont icon-iOS",
    staticStyle: {
      "font-size": "17px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("关注微信公众号")]), _vm._v(" "), _c('p', {
    staticClass: "red"
  }, [_vm._v("扫码即可关注")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.57lace.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "leisikong",
    attrs: {
      "src": "/static/images/leisikong.png",
      "width": "60"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c433fd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topbar/topbar.vue
// module id = 800
// module chunks = 39